module.exports = __webpack_public_path__ + "img/19_20.3540318d.png";